import React, { useState, useEffect, useMemo } from "react";
import { Box, Button, Stack, styled } from "@mui/material";
import { Grid, Typography } from "@mui/material";
import {
  BodyContainer,
  ButtonAdd,
  Header,
  TopGrid,
} from "../../components/styles";
import Loader from "../../components/components/Loader";
import AddPhoto from "../../images/add_a_photo.png";

import BackIcon from "../../images/undo.svg";
import Search from "../../components/components/Search";
import { ImgBox, OrderBox, SubTitle, Title } from "./style";
import moment from "moment";
import { Link, useHistory } from "react-router-dom";
import Repo from "../../Repository/Repo";

const Btn = styled(Button)((props) => ({
  borderRadius: "17px",
  size: "small",
  boxShadow: "none !important",
  background: props.sel == "true" ? "#4CAF50 !important" : "#AFAFAF !important",
  border: props.sel == "true" ? "1px solid #4CAF50" : "1px solid #AFAFAF",
}));
const StatusBox = styled(Box)((props) => ({
  padding: "2px 5px",
  borderRadius: "2px",
  color:
    props.type == "open"
      ? "#9E9043"
      : props.type == "delivered"
      ? "#449E43"
      : "#9E4343",
  background:
    props.type == "open"
      ? "#FFF2AC"
      : props.type == "delivered"
      ? "#B8FFAC"
      : "#FFACAC",
}));

function ManageOrders() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selected, setSelected] = useState("All");
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    getOrders();
  }, []);

  const getOrders = async () => {
    try {
      setLoading(true);
      let { data } = await Repo.orders({
        request: {
          method: "getOrder",
          data: {
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        setOrders(data.response.data.ordersArr);
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const handleSearch = (e) => {
    const { value } = e.target;
    setSearchText(value);
  };

  const handleFilter = (e) => {
    setSelected(e);
  };

  const filteredItems = useMemo(() => {
    if (selected == "All") {
      if (searchText) {
        let filtered = orders.filter((i) =>
          i?.orderNo
            ?.toString()
            .toLowerCase()
            .startsWith(searchText.toLowerCase())
        );
        return filtered;
      } else {
        return orders;
      }
    } else {
      if (selected == "Open") {
        if (searchText) {
          let filtered = orders.filter(
            (i) =>
              i.status == "open" &&
              i?.orderNo
                ?.toString()
                .toLowerCase()
                .startsWith(searchText.toLowerCase())
          );
          return filtered;
        } else {
          let filtered = orders.filter((i) => i.status == "open");
          return filtered;
        }
      } else if (selected == "Cancelled") {
        if (searchText) {
          let filtered = orders.filter(
            (i) =>
              i.status == "cancelled" &&
              i?.orderNo
                ?.toString()
                .toLowerCase()
                .startsWith(searchText.toLowerCase())
          );
          return filtered;
        } else {
          let filtered = orders.filter((i) => i.status == "cancelled");
          return filtered;
        }
      } else {
        if (searchText) {
          let filtered = orders.filter(
            (i) =>
              i.status == "delivered" &&
              i?.orderNo
                ?.toString()
                .toLowerCase()
                .startsWith(searchText.toLowerCase())
          );
          return filtered;
        } else {
          let filtered = orders.filter((i) => i.status == "delivered");
          return filtered;
        }
      }
    }
  }, [orders.length, searchText, selected]);

  const selectOrder = (item) => {
    history.push({
      pathname: `/inventory/admin/order-details/${item.orderNo}`,
      state: { order: item },
    });
  };

  return (
    <Box sx={{ mt: 5 }}>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center" spacing={1}>
          <Grid
            item
            md={1}
            xs={12}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <ImgBox>
              <img src={AddPhoto} alt="" />
            </ImgBox>
          </Grid>
          <Grid align="center" item md={10} xs={12}>
            <Typography
              variant="h5"
              sx={{ color: "white", fontSize: { md: "1.5rem", xs: "16px" } }}
            >
              Manage Orders
            </Typography>
          </Grid>
          <Grid item md={1} xs={12}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Link to="/inventory/admin/store">
                <ButtonAdd
                  variant="contained"
                  sx={{ textTransform: "none", ml: 0 }}
                >
                  <img src={BackIcon} style={{ marginRight: "8px" }} /> Back
                </ButtonAdd>
              </Link>
            </Box>
          </Grid>
        </TopGrid>
      </Header>
      <BodyContainer sx={{ mt: { md: "100px", sm: "160px", xs: "220px" } }}>
        <Grid container spacing={4} mb="8px">
          <Grid item md={4} xs={12}>
            <Search
              name="searchText"
              text="Search order..."
              value={searchText}
              onChange={handleSearch}
            />
          </Grid>
          <Grid item md={8} xs={12} alignItems="center">
            <Stack direction="row" alignItems="center" spacing="5px">
              <Title sx={{ color: "#737373" }}>Filter orders :</Title>
              <Stack
                direction="row"
                alignItems="center"
                spacing={3}
                flexWrap="wrap"
              >
                <Btn
                  variant="contained"
                  sel={selected == "All" ? "true" : "false"}
                  onClick={() => handleFilter("All")}
                >
                  All
                </Btn>
                <Btn
                  variant="contained"
                  sel={selected == "Open" ? "true" : "false"}
                  onClick={() => handleFilter("Open")}
                >
                  Open
                </Btn>
                <Btn
                  variant="contained"
                  sel={selected == "Cancelled" ? "true" : "false"}
                  onClick={() => handleFilter("Cancelled")}
                >
                  Cancelled
                </Btn>
                <Btn
                  variant="contained"
                  sel={selected == "Delivered" ? "true" : "false"}
                  onClick={() => handleFilter("Delivered")}
                >
                  Delivered
                </Btn>
              </Stack>
            </Stack>
          </Grid>
        </Grid>

        <Box sx={{ maxHeight: "78vh", overflow: "auto", pr: "8px" }}>
          {filteredItems &&
            filteredItems?.map((item, i) => {
              return (
                <OrderBox
                  key={i}
                  sx={{ cursor: "pointer", mb: 0.8 }}
                  onClick={() => selectOrder(item)}
                >
                  <Stack spacing="8px">
                    <Stack direction="row" spacing={1}>
                      <Title sx={{ fontSize: "18px" }}> {item?.orderNo}</Title>
                      <StatusBox type={item.status}>
                        <Typography sx={{ fontSize: "13px" }}>
                          {item.status}
                        </Typography>
                      </StatusBox>
                    </Stack>
                    <SubTitle>Total Items : {item?.items?.length}</SubTitle>
                    {/* <SubTitle>Quantity No</SubTitle> */}
                  </Stack>
                  <Stack alignItems="end" justifyContent="flex-end">
                    <SubTitle>
                      {moment
                        .unix(item.created_at)
                        .format("DD-MM-YYYY hh:mm A")}
                    </SubTitle>
                    <Title sx={{ fontSize: "18px" }}>Rs {item?.total}</Title>
                    <Stack direction="row" spacing="3px">
                      <SubTitle>Status :</SubTitle>
                      <SubTitle
                        sx={{
                          fontSize: "15px",
                          color:
                            item.status == "open"
                              ? "#D9BF32"
                              : item.status == "delivered"
                              ? "#32D942"
                              : "#D93232",
                        }}
                      >
                        {item.status}
                      </SubTitle>
                    </Stack>
                  </Stack>
                </OrderBox>
              );
            })}
        </Box>

        {loading && <Loader loading={true} />}
      </BodyContainer>
    </Box>
  );
}

export default ManageOrders;
